import type { CSSProperties, FC, ReactNode } from 'react';

import { FlexContentRegion } from '@/shared/components/layouts/flex';

interface FinancialAnalysisSplitViewProps {
    chart: ReactNode;
    gap?: CSSProperties['gap'];
    height?: CSSProperties['height'];
    table: ReactNode;
}

const paneStyle: CSSProperties = {
    flex: '1 1 0%',
    minHeight: 0,
    minWidth: 0,
};

const FinancialAnalysisSplitView: FC<FinancialAnalysisSplitViewProps> = ({ chart, gap = '3rem', height, table }) => (
    <FlexContentRegion
        overflow='hidden'
        style={{
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap,
            padding: '2rem 1.5rem 0',
            ...(height ? { flex: 'none', height } : {}),
        }}
    >
        <div data-financial-pane='chart' style={paneStyle}>
            {chart}
        </div>
        <div data-financial-pane='table' style={paneStyle}>
            {table}
        </div>
    </FlexContentRegion>
);

export default FinancialAnalysisSplitView;
